import React from 'react';

interface DelayConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

const UNIT_LIMITS: Record<string, { max: number; label: string }> = {
  seconds: { max: 300, label: 'máx 300 (5 min)' },
  minutes: { max: 5, label: 'máx 5' },
};

export const DelayConfig: React.FC<DelayConfigProps> = ({ config, onChange }) => {
  const unit = config.unit || 'seconds';
  const limits = UNIT_LIMITS[unit] || UNIT_LIMITS.seconds;

  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs text-blue-700 leading-relaxed">
        <strong>Como funciona:</strong> Pausa a execução do fluxo pelo tempo definido antes de seguir para o próximo nó. Útil para simular digitação, aguardar processos ou dar tempo ao usuário para ler uma mensagem.
      </div>
      <div className="flex gap-2">
        <div className="flex-1">
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Duração
          </label>
          <input
            type="number"
            className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            min={1}
            max={limits.max}
            value={config.duration || 1}
            onChange={(e) => {
              const val = parseInt(e.target.value) || 1;
              onChange('duration', Math.min(limits.max, Math.max(1, val)));
            }}
          />
          <p className="text-[10px] text-slate-400 mt-1">{limits.label}</p>
        </div>
        <div className="flex-1">
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Unidade
          </label>
          <select
            className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={unit}
            onChange={(e) => {
              const newUnit = e.target.value;
              const newLimits = UNIT_LIMITS[newUnit] || UNIT_LIMITS.seconds;
              const currentDuration = config.duration || 1;
              onChange('unit', newUnit);
              if (currentDuration > newLimits.max) {
                onChange('duration', newLimits.max);
              }
            }}
          >
            <option value="seconds">Segundos</option>
            <option value="minutes">Minutos</option>
          </select>
        </div>
      </div>
    </div>
  );
};
